export * from './ecall-statusnum2statusname.directive';
export * from './ecall-statusnum2statusname.module';



// WEBPACK FOOTER //
// /Users/adminuser/Documents/pentagon/pentagon-admin/src/app/directives/ecall-statusnum2statusname/index.ts